import { Box, Typography } from "@mui/material";
import React from "react";

const StatisticRow = (props) => {
  const { field, value } = props;

  return (
    <Box sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
      <Box sx={{ display: "flex", flex: 1 }}>
        <Typography variant="body">{field}</Typography>
      </Box>
      <Box sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
        <Typography>{value}</Typography>
      </Box>
    </Box>
  );
};

export default StatisticRow;
